/**
 * OdysseyModelClass enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file OdysseyModelClass.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum OdysseyModelClass {
  OTHER       = 0x00,
  EFFECT      = 0x01,
  TILE        = 0x02,
  CREATURE    = 0x04,
  DOOR        = 0x08,
  LIGHTSABER  = 0x10,
  PLACEABLE   = 0x20,
  FLYER       = 0x40,
};